module.exports = __webpack_public_path__ + "static/img/card_2_2.a6c3c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/card_2_2.png
// module id = xdy/
// module chunks = 0